import { cdnClient } from './cdn/client';
import { cxmRulesClient } from './cxm-rules/client';
import { ocapiClient } from './ocapi/client';
import { createOcapiAuthTokenProvider } from './utils/create-ocapi-auth-token-provider';
import { createOcapiLoyaltyAuthTokenProvider } from './utils/create-ocapi-loyalty-auth-token-provider';
export const updateApiClients = (config) => {
    const { api, cxm, cdn, loyalty } = config;
    // Reuse the same cached auth token provider for OCAPI and CXM Rules.
    const authTokenProvider = createOcapiAuthTokenProvider(api.authTokenProvider);
    const loyaltyAuthTokenProvider = createOcapiLoyaltyAuthTokenProvider(loyalty.authentication);
    ocapiClient.update(Object.assign(Object.assign({}, api), { authTokenProvider, loyaltyAuthTokenProvider, clientId: 'OCC' }));
    cxmRulesClient.update(Object.assign(Object.assign({}, cxm), { authTokenProvider }));
    cdnClient.update(cdn);
};
//# sourceMappingURL=update-api-clients.js.map